import React from 'react';
import ProjectList from '@modules/BillOfMaterials/Components/BillOfMaterials/ProjectsList/ProjectsList';
import css from './BillOfMaterials.module.css';
import TemplatesView from '@modules/BillOfMaterials/Components/BillOfMaterials/TemplatesView/TemplatesView';

const BillOfMaterials: React.FC = () => {
    return (
        <section className={css.section}>
            <div className={css.header}>Bill of Materials</div>
            <ProjectList />
            <TemplatesView />
        </section>
    );
};

export default BillOfMaterials;
